import React from "react";
import { Box, Text, Link } from "@chakra-ui/react";

export default function IntroText() {
  return (
    <Box
      bg="white"
      color="gray.800"
      borderRadius="md"
      borderWidth="1px"
      borderColor="gray.200"
      p={{ base: 4, md: 6 }}
    >
      <Text mb={3} fontSize="sm" lineHeight="1.6">
        The U.S. Center for SafeSport’s Centralized Disciplinary Database is a
        resource designed to keep the public informed when individuals connected
        with the U.S. Olympic & Paralympic Movements are either subject to
        certain temporary restrictions pending investigation by the Center or
        are subject to certain sanctions after an investigation found them in
        violation of the{" "}
        <Link
          color="navy.800"
          fontWeight="semibold"
          textDecoration="underline"
          href="https://uscenterforsafesport.org/response-and-resolution/safesport-code/"
          isExternal
        >
          SafeSport Code (opens in new tab)
        </Link>
        . The database also contains certain eligibility decisions made by the
        National Governing Bodies (NGB), their Local Affiliated Organizations
        (LAO), or the U.S. Olympic & Paralympic Committee (USOPC), including
        those rendered prior to the establishment of the Center.
      </Text>

      <Text mb={3} fontSize="sm" lineHeight="1.6">
        Users can search the database by Name, City, State, and/or Sport
        Affiliation(s). Enter as much (or as little) information as you know.
        Search results will include the Participant’s Name, City, State, Sport
        Affiliation(s), Decision Date, Misconduct, and Action Taken.
      </Text>

      <Text mb={3} fontSize="sm" lineHeight="1.6">
        What if you recognize a name in the CDD? What if you search for a name
        and they are not on the list? The CDD can bring up many feelings.{" "}
        <Link
          color="navy.800"
          fontWeight="semibold"
          textDecoration="underline"
          href="https://uscenterforsafesport.org/cdd-guide"
          isExternal
        >
          Read tips and resources in the CDD guide (opens in new tab).
        </Link>
      </Text>

      <Text mb={3} fontSize="sm" lineHeight="1.6">
        <Link
          color="navy.800"
          fontWeight="semibold"
          textDecoration="underline"
          href="https://uscenterforsafesport.org/wp-content/uploads/2019/12/CDD-Link-1-overview-and-definitions-v2.pdf"
          isExternal
        >
          Download the CDD overview and definitions PDF (opens in new tab)
        </Link>{" "}
        to learn about the types of records published and the information
        included within the Centralized Disciplinary Database.
      </Text>

      <Text mb={3} fontSize="sm" lineHeight="1.6">
        <Link
          color="navy.800"
          fontWeight="semibold"
          textDecoration="underline"
          href="https://uscenterforsafesport.org/wp-content/uploads/2020/06/CDD-Link-2-NGB-LAO-USOPC-mattersv5.pdf"
          isExternal
        >
          Download the NGB/LAO/USOPC misconduct PDF (opens in new tab)
        </Link>{" "}
        to see the types of misconduct handled by the NGBs, LAOs, and USOPC, and
        what’s included in the Centralized Disciplinary Database.
      </Text>

      <Text fontSize="sm" lineHeight="1.6">
        IMPORTANT: By accessing and using the Centralized Disciplinary
        Database, you agree to accept the U.S. Center for SafeSport’s{" "}
        <Link
          color="navy.800"
          fontWeight="semibold"
          textDecoration="underline"
          href="https://uscenterforsafesport.org/terms-of-use/"
          isExternal
        >
          Terms and Conditions (opens in new tab)
        </Link>
        .
      </Text>
    </Box>
  );
};
